import React from "react";
import { HttpStatusCodes } from "../../../../core/types";
import ProductDetailNotification from "../Notifications";
import { Loading } from "../../../..";
import Header from "../Header";

var ProductView = function ProductView(_ref) {
  var productData = _ref.productData,
      isLoading = _ref.isLoading,
      error = _ref.error,
      productNotFoundMsg = _ref.productNotFoundMsg,
      productErrorMsg = _ref.productErrorMsg,
      productLoadingMsg = _ref.productLoadingMsg;

  if (error) {
    var notificationMsg = error.code === HttpStatusCodes.NotFound ? productNotFoundMsg : productErrorMsg;
    return /*#__PURE__*/React.createElement(ProductDetailNotification, {
      notification: notificationMsg || ""
    });
  }

  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loading, {
      text: productLoadingMsg
    });
  }

  if (!productData) {
    return /*#__PURE__*/React.createElement(ProductDetailNotification, {
      notification: productErrorMsg || ""
    });
  }

  return /*#__PURE__*/React.createElement(Header, {
    product_image: productData.product_image,
    product_title: productData.product_title,
    starting_price: productData.starting_price,
    starting_price_prepend: productData.starting_price_prepend,
    tagline: productData.tagline
  });
};

ProductView.displayName = "ProductView";
export default ProductView;